import React from "react";
import SingleContentPage from "../Shared/SingleContentPage";

const MediaLibrary = () => {
  return <SingleContentPage title="Media Library" moduleKey="media-library" />;
};

export default MediaLibrary;
